import debugHelper from './debug'

/**
 * 浏览器调用语音合成接口
 * @param {Object} param 百度语音合成接口参数
 * 请参考 https://ai.baidu.com/docs#/TTS-API/41ac79a6
 * @param {Object} options 跨域调用api参数
 *           timeout {number} 超时时间 默认不设置为60秒
 *           volume {number} audio控件音量，范围 0-15
 *           hidden {boolean} 是否隐藏audio控件
 *           autoDestroy {boolean} 播放音频完毕后是否自动删除控件
 *           onInit {Function} 创建完audio控件后调用
 *           onSuccess {Function} 远程语音合成完成，并且返回音频文件后调用
 *           onError {Function}  远程语音合成完成，并且返回错误字符串后调用
 *           onTimeout {Function} 超时后调用，默认超时时间为60秒
 */
function btts(param, options) {
	var url = 'https://tsn.baidu.com/text2audio'
	var opt = options || {}

	// 如果浏览器支持，可以设置autoplay，但是不能兼容所有浏览器
	// var audio = document.createElement('audio')
	var audio = document.getElementById('audioPlayer')
	if (opt.autoplay) {
		audio.setAttribute('autoplay', 'autoplay')
	}

	// 隐藏控制栏
	if (!opt.hidden) {
		audio.setAttribute('controls', 'controls')
	} else {
		audio.style.display = 'none'
	}

	// 设置音量
	if (typeof opt.volume !== 'undefined') {
		audio.volume = opt.volume
	}

	// 调用onInit回调
	isFunction(opt.onInit) && opt.onInit(audio)

	// 默认超时时间60秒
	var DEFAULT_TIMEOUT = 60000
	var timeout = opt.timeout || DEFAULT_TIMEOUT

	// 创建XMLHttpRequest对象
	var xhr = new XMLHttpRequest()
	xhr.open('POST', url)

	// 创建form参数
	var data = {}
	for (var p in param) {
		data[p] = param[p]
	}

	// 赋值预定义参数
	data.cuid = data.cuid || data.tok
	data.ctp = 1
	data.lan = data.lan || 'zh'

	// 序列化参数列表
	var fd = []
	for (var k in data) {
		fd.push(k + '=' + encodeURIComponent(data[k]))
	}

	// 用来处理blob数据
	var frd = new FileReader()
	xhr.responseType = 'blob'
	xhr.send(fd.join('&'))

	// 用timeout可以更兼容的处理兼容超时
	var timer = setTimeout(function () {
		xhr.abort()
		isFunction(opt.onTimeout) && opt.onTimeout()
	}, timeout)

	xhr.onreadystatechange = function () {
		if (xhr.readyState == 4) {
			clearTimeout(timer)
			if (xhr.status == 200) {
				if (xhr.response.type === 'audio/mp3') {
					// 在body元素下apppend音频控件
					document.body.append(audio)

					// Should work in Safari/on mobile
					// All browsers, except Firefox
					try {
						audio.setAttribute('src', window.webkitURL.createObjectURL(xhr.response))
					} catch (err) {
						// Firefox
						audio.setAttribute('src', URL.createObjectURL(xhr.response))
					}

					// audio.setAttribute('src', URL.createObjectURL(xhr.response))

					// autoDestory设置则播放完后移除audio的dom对象
					if (opt.autoDestory) {
						audio.onended = function () {
							audio.setAttribute('src', '')

							// document.body.removeChild(audio)
						}
					}

					isFunction(opt.onSuccess) && opt.onSuccess(audio)
				}

				// 用来处理错误
				if (xhr.response.type === 'application/json') {
					frd.onload = function () {
						var text = frd.result
						isFunction(opt.onError) && opt.onError(text)
					}
					frd.readAsText(xhr.response)
				}
			}
		}
	}

	// 判断是否是函数
	function isFunction(obj) {
		if (Object.prototype.toString.call(obj) === '[object Function]') {
			return true
		}
		return false
	}
}
/**
 * 播放语音
 * @param {Object} params
 * 键值对格式,
 * 其中params.text为播放内容,
 * params.token为百度语音授权Token()
 */
function audioText(params) {
	var audio = null
	// debugHelper.log(btts)
	debugHelper.log(params)
	audio = btts(
		{
			// 设置播放内容
			tex: params.text,
			// tok: '24.d21d8e0041f3d07e55aaea93638aee25.2592000.1548770136.282335-14923304',
			// 设置token
			tok: params.token,
			// 播放速度
			spd: 5,
			pit: 5,
			// 音量
			vol: 15,
			per: 4
		},
		{
			volume: 0.3,
			autoDestroy: true,
			timeout: 10000,
			hidden: false,
			onInit: function (htmlAudioElement) { },
			onSuccess: function (htmlAudioElement) {
				audio = htmlAudioElement
				// alert('audio.play')
				audio.play()
				// alert('success')
			},
			onError: function (text) {
				debugHelper.log(text)
				alert(text)
			},
			onTimeout: function () {
				debugHelper.log('timeout')
			}
		}
	)
}

export default audioText
